import React from 'react';

const CoordinatesPicker = React.lazy(() => import('./CoordinatesPicker'));

export { CoordinatesPicker };
